/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, November 1st 2021, 8:18:34 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { Box, Divider } from "@mui/material";

export const RightAlignContainer = ({ children }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
      <React.Fragment>
        <Box sx={{ flex: "1 1 auto" }} />
        {children}
      </React.Fragment>
    </Box>
  );
};

export const Spacer = () => <Box sx={{ paddingTop: 2 }} />;

export const PaddedDivider = () => {
  return (
    <React.Fragment>
      <Spacer />
      <Divider />
      <Spacer />
    </React.Fragment>
  );
};

interface StackedSelectionCardProps extends Pick<React.HTMLAttributes<HTMLDivElement>, "onClick"> {
  actionButton: React.ReactNode;
  isSelected: boolean;
  label: React.ReactNode;
  icon: React.ReactNode;
}

export const StackedSelectionCard = ({ onClick, label, icon, actionButton, isSelected }: StackedSelectionCardProps) => {
  return (
    <div
      className={`os-org-card d-flex ${isSelected ? "selected" : ""}`}
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <div className="os-org-card-part1 d-flex">
        <figure className="os-org-image">{icon}</figure>
        <div className="os-org-content">{label}</div>
      </div>
      <div className="os-org-card-part2 d-flex">
        <div className="os-org-cta-switch">{actionButton}</div>
      </div>
    </div>
  );
};
